import { render, staticRenderFns } from "./bairong.vue?vue&type=template&id=897deeb8&scoped=true"
import script from "./bairong.vue?vue&type=script&lang=js"
export * from "./bairong.vue?vue&type=script&lang=js"
import style0 from "./bairong.vue?vue&type=style&index=0&id=897deeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897deeb8",
  null
  
)

export default component.exports